// extracted by mini-css-extract-plugin
module.exports = {"light":"TaskClear_light__381Wz","dark":"TaskClear_dark__19zan"};